var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHardDriveArt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "#FFF8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6667 16H9.33337",
    stroke: "#FABC2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6334 11.4067L9.33337 16V20C9.33337 20.3536 9.47385 20.6928 9.7239 20.9428C9.97395 21.1928 10.3131 21.3333 10.6667 21.3333H21.3334C21.687 21.3333 22.0261 21.1928 22.2762 20.9428C22.5262 20.6928 22.6667 20.3536 22.6667 20V16L20.3667 11.4067C20.2563 11.1845 20.0862 10.9976 19.8753 10.8668C19.6645 10.7361 19.4214 10.6668 19.1734 10.6667H12.8267C12.5787 10.6668 12.3355 10.7361 12.1247 10.8668C11.9139 10.9976 11.7438 11.1845 11.6334 11.4067Z",
    stroke: "#FABC2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.6667H12.0067",
    stroke: "#FABC2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 18.6667H14.6733",
    stroke: "#FABC2F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHardDriveArt);
export default __webpack_public_path__ + "static/media/hardDriveArt.4045c596785e25430c26326fcc7f2ffb.svg";
export { ForwardRef as ReactComponent };